module.exports = __webpack_public_path__ + "03_short_brown.cf8fd853.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/03_short_brown.png
// module id = dlQ+
// module chunks = 0